import { createAsyncThunk } from '@reduxjs/toolkit';
import { getWhatsAppChatByContact } from 'services/whatsAppMessaging';
import { IWhatsAppChat } from 'services/whatsAppMessaging/types';

interface IGetWhatsAppChatByContactPayload {
  crmId: number;
  contactId: string;
}

export const ThunkGetWhatsAppChatByContact = createAsyncThunk<
  IWhatsAppChat | null,
  IGetWhatsAppChatByContactPayload
>('whatsAppMessaging/getChatByContact', async ({ crmId, contactId }) => {
  try {
    const { data } = await getWhatsAppChatByContact(crmId, contactId);
    return data;
  } catch {
    return null;
  }
});
